import Vue from 'vue';
import Vuex from 'vuex';
// import dispatchActionForAllModules from '@utils/dispatch-action-for-all-modules';

import modules from './modules';
import http from "@state/http";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',

  state:{
    user: [],
    role: [],
  },
  mutations:{
    setUserPermission(state, user){
      state.user = user;
    },
    setUserRole(state, role){
      state.role = role;
    }
  },
  actions:{
    getUserPermission(context){
      http.get('api/getUserPermission')
          .then(resource => {
            context.commit('setUserPermission', resource.data.user);
          }).catch()
    },
    getUserRole(context){
      http.get('api/getUserRole')
          .then(resource => {
            context.commit('setUserRole', resource.data.role);
          }).catch()
    }
  },

});

export default store;

// Automatically run the `init` action for every module,
// if one exists.
// dispatchActionForAllModules('init');
